'use client';

import { dismissToast, subscribeToasts, type Toast, type ToastLevel } from '@/domains/common/toast';
import { FunctionComponent, useEffect, useState } from 'react';

const LEVEL_BORDER: Record<ToastLevel, string> = {
  error: 'border-l-[3px] border-l-rose',
  info: 'border-l-[3px] border-l-acc',
  success: '',
};

export const Toasts: FunctionComponent = () => {
  const [toasts, setToasts] = useState<Toast[]>([]);

  useEffect(() => {
    return subscribeToasts(setToasts);
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-5 right-5 z-[300] space-y-2" role="status" aria-live="polite">
      {toasts.map(t => (
        <div
          key={t.id}
          className={`flex min-w-[300px] animate-[slide-in_0.25s_cubic-bezier(0.2,0.7,0.3,1)_forwards] items-center gap-2.5 rounded-md border border-line-2 bg-white px-3.5 py-[11px] font-sans text-ink shadow-[0_8px_24px_-8px_rgba(15,17,21,0.18),0_1px_2px_rgba(15,17,21,0.06)] ${LEVEL_BORDER[t.level]}`}
        >
          <div className="flex flex-col gap-px">
            <div className="text-[12.5px] font-semibold text-ink">{t.message}</div>
            {t.detail ? <div className="text-[11.5px] text-ink-3">{t.detail}</div> : null}
          </div>
          <button
            type="button"
            className="ml-auto cursor-pointer border-none bg-transparent px-1 text-base leading-none text-ink-4 hover:text-ink"
            onClick={() => dismissToast(t.id)}
            aria-label="Dismiss"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};
